/**
 * @generated SignedSource<<b794ebbbca80ef2d418697937003d8aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetEmployeeLeaveInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  teamIds: ReadonlyArray<string>;
  whitelistLeaveReasonIds: ReadonlyArray<string>;
};
export type WAEmployeeLeaveMutation$variables = {
  input: CreateWidgetEmployeeLeaveInput;
  storecastId: string;
};
export type WAEmployeeLeaveMutation$data = {
  readonly dashboard: {
    readonly createWidgetEmployeeLeave: {
      readonly id: string;
    };
  };
};
export type WAEmployeeLeaveMutation = {
  response: WAEmployeeLeaveMutation$data;
  variables: WAEmployeeLeaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetEmployeeLeave",
        "kind": "LinkedField",
        "name": "createWidgetEmployeeLeave",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAEmployeeLeaveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAEmployeeLeaveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2862621f5cd37da357190974fb9a55e2",
    "id": null,
    "metadata": {},
    "name": "WAEmployeeLeaveMutation",
    "operationKind": "mutation",
    "text": "mutation WAEmployeeLeaveMutation(\n  $storecastId: ID!\n  $input: CreateWidgetEmployeeLeaveInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetEmployeeLeave(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1dc78e0543dfd040909d998db97837e4";

export default node;
